import React, { useEffect, useState } from "react";
import ArticlePreview from "../../components/BlogPreview/BlogPreview";
import Footer from "../../components/Footer/Footer";

const Articles = () => {
  const [posts, setPosts] = useState([]);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("name");
  const [filter, setFilter] = useState("");

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/postsManifest.json")
      .then((res) => res.json())
      .then((data) => {
        setPosts(data.sort((a, b) => b.date.localeCompare(a.date)));
      });
  }, []);

  // Latest 3 articles, sorted by date descending
  const latestPosts = [...posts]
    .sort((a, b) => b.date.localeCompare(a.date))
    .slice(0, 2);

  // Filter, search, and sort all articles (including latest)
  let filteredPosts = posts;
  if (search) {
    filteredPosts = filteredPosts.filter(
      (post) =>
        post.title.toLowerCase().includes(search.toLowerCase()) ||
        post.excerpt.toLowerCase().includes(search.toLowerCase())
    );
  }
  if (filter) {
    filteredPosts = filteredPosts.filter((post) =>
      post.title.toLowerCase().includes(filter.toLowerCase())
    );
  }
  // Default sort by name for all articles
  if (sort === "name") {
    filteredPosts = [...filteredPosts].sort((a, b) =>
      a.title.localeCompare(b.title)
    );
  } else if (sort === "date") {
    filteredPosts = [...filteredPosts].sort((a, b) =>
      b.date.localeCompare(a.date)
    );
  }

  return (
    <>
      <main style={{ minHeight: "60vh", padding: "2rem 0 0 0" }}>
        <h1 style={{ textAlign: "center", color: "var(--text)" }}>Scrolls</h1>
        <section style={{ width: "100%", maxWidth: 900, margin: "0 auto" }}>
          <ArticlePreview posts={latestPosts} title="📜 Latest Scrolls" />
        </section>
        <section style={{ maxWidth: 900, margin: "2rem auto 0 auto" }}>
          <div className="blog-search-bar">
            <input
              type="text"
              placeholder="Search scrolls..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              style={{ flex: 1, minWidth: 180 }}
            />
            <select value={sort} onChange={(e) => setSort(e.target.value)}>
              <option value="name">Sort by Name</option>
              <option value="date">Sort by Date</option>
            </select>
            <input
              type="text"
              placeholder="Filter by keyword..."
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              style={{ minWidth: 180 }}
            />
          </div>
          <ArticlePreview posts={filteredPosts} title="📜 All Scrolls" />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Articles;
